export default "__VITE_ASSET__DrgXSxv5__"